"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirectToLogIn = exports.getFullPath = void 0;
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var getFullPath = function (path) {
    var _a = window.location, host = _a.host, protocol = _a.protocol;
    var publicUrl = process.env.PUBLIC_URL;
    var urlPath = publicUrl && publicUrl.charAt(publicUrl.length - 1) === '/' && path.charAt(0) === '/'
        ? path.slice(1)
        : path;
    return [protocol, '//', host, publicUrl, urlPath].join('');
};
exports.getFullPath = getFullPath;
var redirectToLogIn = function (history) {
    if (history === void 0) { history = {}; }
    if (!(0, isEmpty_1.default)(history)) {
        var currentPath = history.location.pathname.concat(history.location.search);
        var fullPath = (0, exports.getFullPath)(currentPath);
        var encodedPath = encodeURIComponent(fullPath);
        window.location.href = "/?redirect_to=".concat(encodedPath);
    }
    else {
        window.location.href = '/';
    }
};
exports.redirectToLogIn = redirectToLogIn;
